import { NativeBridge } from "@swiggy-private/native-bridge";
import { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge/dist/interfaces";
import { mockSwgyHeaders } from "../tests/mocks";

let bridgeSdk: NativeBridge | null = null;

export const initBridgeSdk = (sdk?: NativeBridge): NativeBridge => {
    if (bridgeSdk && !sdk) {
        return bridgeSdk;
    }

    bridgeSdk = sdk || new NativeBridge(null);
    return bridgeSdk;
};

/**
 * get instance for bridge sdk via getBridgeSdk
 * @returns instance for bridge SDK
 */
export const getBridgeSdk = (): NativeBridge => bridgeSdk || initBridgeSdk();

export const isBrowserEnv = () => typeof window !== "undefined";

let swHeaders: GetSwiggyHeadersResponsePayload | undefined;

export const getSwiggyHeaders = async (): Promise<GetSwiggyHeadersResponsePayload | undefined> => {
    // swHeaders is already initialized
    if (swHeaders) {
        return swHeaders;
    }

    // get header value, store & return
    if (process.env.NODE_ENV === "development") {
        swHeaders = mockSwgyHeaders;
        return mockSwgyHeaders;
    } else {
        swHeaders = await getBridgeSdk()
            .getSwiggyHeadersFromClient()
            .catch(() => {
                return Promise.resolve(undefined);
            });
    }

    return swHeaders;
};

export const closeWebview = () => {
    const sdk = getBridgeSdk();
    if (sdk?.close) {
        return sdk.close().catch(() => void 0);
    } else {
        window.location.href = "/";
    }
};

export const changeWebviewHeight = (height: number) => {
    const sdk = getBridgeSdk();
    if (sdk?.updateWebViewHeight) {
        return sdk
            .updateWebViewHeight({
                height,
            })
            .catch(() => void 0);
    }
};
